import React from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ClaimGroupBreadcrumbLinks from '../../claim_group/edit/ClaimGroupBreadcrumbLinks';
import ClaimGroupSidebar from '../setup/ClaimGroupSidebar';
import claimGroupService from '../../services/claim_group.service';
import { Loader } from '../../util/Loader';
export default function ClaimGroupPageContainer(_ref) {
  let {
    onClaimGroupNotLoaded = null,
    accountType,
    children,
    // pass all components that should be rendered on the page
    highlightedMenuItem,
    // string page link e.g. 'project_overview'
    setClaimGroup: setPageClaimGroup,
    // pageClaimGroup is needed only as a way to make sure that the parent component has access to the claim group.
    // Therefore anything rendered within it will also have access. Change this if you find a better and cleaner approach.
    claimGroup: pageClaimGroup
  } = _ref;
  // change this if not all pages require this specific way of setting the claim group
  const {
    claimGroupId
  } = useParams();
  const [claimGroup, setClaimGroup] = claimGroupService.useGetClaimGroup(claimGroupId, setPageClaimGroup);
  if (!(claimGroup !== null && claimGroup !== void 0 && claimGroup.id) || !(pageClaimGroup !== null && pageClaimGroup !== void 0 && pageClaimGroup.id)) {
    return onClaimGroupNotLoaded ? onClaimGroupNotLoaded() : /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimGroupSidebar, {
    claimGroup: claimGroup,
    accountType: accountType,
    highlightedMenuItem: highlightedMenuItem,
    company: claimGroup.company,
    claims: claimGroup.claims
  }), /*#__PURE__*/React.createElement(ClaimGroupBreadcrumbLinks, {
    claimGroup: claimGroup
  }), children);
}